<template>
  <div>
    <b-navbar
      v-if="$smallScreen"
      class="navbar-light bg-light shadow fixed-top header-nav mobile"
      style="z-index: 1039"
    >
      <b-nav class="w-100 d-flex justify-content-between align-items-center">
        <b-nav-item class="p-1">
          <div class="btn-icon" @click="goBack()">
            <font-awesome-icon icon="arrow-left" fixed-width />
            Back
          </div>
        </b-nav-item>
        <div>
          <input
            id="attachmentInput"
            type="file"
            hidden
            multiple
            :accept="supportedTypesList.join(',')"
            @input="inputFiles($event.target.files)"
          />
          <span v-if="numberOfAttachments > 0" class="text-primary px-1">({{ numberOfAttachments }})</span>
          <b-button variant="secondary" size="sm" :disabled="offline || uploadingFiles" @click="selectAttachment()">
            <div v-if="uploadingFiles" class="text-center px-1">
              <b-spinner small></b-spinner>
            </div>
            <font-awesome-icon v-else icon="camera" fixed-width size="lg" />
          </b-button>
        </div>
      </b-nav>
    </b-navbar>
    <b-card
      id="unit-card"
      :class="$smallScreen ? 'rounded-0' : 'overflow-auto'"
      :style="`min-height: 90vh; ${$smallScreen ? '' : 'max-height: 90vh;'}`"
    >
      <div v-if="notFound">
        <p>Unit not found.</p>
      </div>
      <div v-else-if="loading" class="text-center py-4">
        <b-spinner></b-spinner>
      </div>
      <div v-else>
        <h2 class="card-header">Unit Detail</h2>

        <b-row no-gutters>
          <b-col>
            <b-form-group label="Vin/Serial ID:" label-for="vin" label-class="col-head">
              <div id="vin">{{ unit.vin || NA }}</div>
            </b-form-group>

            <b-form-group label="Fleet Unit ID:" label-for="fleetUnitId" label-class="col-head">
              <div id="fleetUnitId">{{ unit.fleetUnitId || NA }}</div>
            </b-form-group>

            <b-form-group label="Location:" label-for="location" label-class="col-head">
              <div id="location">{{ unitLocation || NA }}</div>
            </b-form-group>

            <b-form-group label="Customer:" label-for="customer" label-class="col-head">
              <div id="customer">{{ unit.customerId }} - {{ unit.customerName }}</div>
            </b-form-group>

            <b-form-group label="Unit Status:" label-for="unitStatus" label-class="col-head">
              <div id="unitStatus">{{ unitStatus || NA }}</div>
            </b-form-group>

            <b-form-group label="Unit Type:" label-for="unitType" label-class="col-head">
              <div id="unitType">{{ unitType || NA }}</div>
            </b-form-group>

            <b-form-group label="Year Make Model:" label-for="yearMakeModel" label-class="col-head">
              <div id="yearMakeModel">{{ unit.year }} {{ unit.make }} {{ unit.model }}</div>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
// vuex
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { RootGetters } from '@/shared/store/types';
import { LookupGetters } from '@/shared/store/lookup/types';
import { UnitActions, UnitGetters, UnitMutations } from '@/shared/store/unit/types';
// mixins
import UploadMixin from '@/shared/mixins/UploadMixin';

export default {
  name: 'UnitPage',
  mixins: [UploadMixin],
  data() {
    return {
      loading: false,
      notFound: false,
      NA: 'N/A'
    };
  },
  computed: {
    ...mapGetters({
      offline: RootGetters.GET_OFFLINE,
      unit: UnitGetters.GET_UNIT,
      unitStatusesMap: LookupGetters.GET_UNIT_STATUSES_MAP,
      unitTypesMap: LookupGetters.GET_UNIT_TYPES_MAP,
      locationsMap: LookupGetters.GET_LOCATIONS_MAP
    }),
    unitId() {
      return this.$route.params.unitId;
    },
    attachmentInput() {
      return document.getElementById('attachmentInput');
    },
    numberOfAttachments() {
      return this.unit?.attachments?.filter(a => !a.dateRemoved).length;
    },
    unitLocation() {
      const unitLocation = this.locationsMap[this.unit.locationId];
      return unitLocation?.description;
    },
    unitStatus() {
      const unitStatus = this.unitStatusesMap[this.unit.unitStatusId];
      return unitStatus?.description;
    },
    unitType() {
      const unitType = this.unitTypesMap[this.unit.unitTypeId];
      return unitType?.description;
    }
  },
  created: async function () {
    await this.loadPage();
  },
  methods: {
    ...mapActions([UnitActions.FETCH_UNIT]),
    ...mapMutations([UnitMutations.SET_ATTACHMENTS]),
    goBack() {
      this.$router.back();
    },
    async loadPage() {
      this.loading = true;
      try {
        await this[UnitActions.FETCH_UNIT](this.unitId);
      } catch (error) {
        if (error.response && error.response.status == 404) {
          this.notFound = true;
        }
      } finally {
        this.loading = false;
      }
    },
    selectAttachment() {
      this.attachmentInput.click();
    },
    async inputFiles(fileList) {
      const files = [...fileList];
      var attachments = await this.uploadFiles(files);
      this[UnitMutations.SET_ATTACHMENTS](attachments);
      this.attachmentInput.value = null;
    }
  }
};
</script>
